import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React, { useState } from 'react';
import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import { useConfigContextLoose } from '../config-provider/config-provider.js';

/**
 * @deprecated This component will be replaced by the new `Dropdown` component made on top of floating-ui from lab in the future.
 * An extension of Tippy. See [Tippy props](https://atomiks.github.io/tippyjs/v6/all-props/) for all options.
 */
var Dropdown = function Dropdown(_a) {
  var _b;
  var children = _a.children,
    className = _a.className,
    openOnHover = _a.openOnHover,
    hideOnSelect = _a.hideOnSelect,
    visible = _a.visible,
    trigger = _a.trigger,
    content = _a.content,
    appendTo = _a.appendTo,
    _onShow = _a.onShow,
    _onHidden = _a.onHidden,
    otherProps = __rest(_a, ["children", "className", "openOnHover", "hideOnSelect", "visible", "trigger", "content", "appendTo", "onShow", "onHidden"]);
  var _useState = useState(false),
    hideOnSelectVisibilityState = _useState[0],
    setHideOnSelectVisibilityState = _useState[1];
  var _useConfigContextLoos = useConfigContextLoose(),
    getOverlayContainer = _useConfigContextLoos.getOverlayContainer;
  var appendToLocal = (_b = appendTo !== null && appendTo !== undefined ? appendTo : getOverlayContainer === null || getOverlayContainer === undefined ? undefined : getOverlayContainer()) !== null && _b !== undefined ? _b : 'parent';
  var isVisibleSet = typeof visible === 'boolean';
  // do not change this `onclick` into click. expanded dropdowns will persist with click.
  var triggerExtended = trigger || openOnHover ? 'mouseenter focus onclick' : 'click';
  /**
   * Tippy doesn't remove components from the DOM properly, so if you have a lot
   * of memory heavy dropdowns on a page, it can crash the page. That's why we
   * have this manual override that forces the content to be removed from DOM:
   */
  var _React$useState = React.useState(isVisibleSet && visible),
    shouldRenderContent = _React$useState[0],
    setShouldRenderContent = _React$useState[1];
  var shouldHideOnSelect = hideOnSelect !== undefined && (typeof hideOnSelect === 'boolean' ? hideOnSelect : hideOnSelect.hideOnContentClick);
  var isDropdownVisible = function isDropdownVisible() {
    if (isVisibleSet) {
      return visible;
    }
    if (shouldHideOnSelect) {
      return hideOnSelectVisibilityState;
    }
    return undefined;
  };
  var toggleHideOnSelectVisibilityState = function toggleHideOnSelectVisibilityState() {
    return setHideOnSelectVisibilityState(function (currentVisibilityState) {
      return !currentVisibilityState;
    });
  };
  var handleClickOutside = function handleClickOutside() {
    if (shouldHideOnSelect && typeof hideOnSelect !== 'boolean' && hideOnSelect.hideOnOutsideClick) {
      setHideOnSelectVisibilityState(false);
    }
  };
  return jsx("div", {
    className: classNames('cogs-v10', 'cogs-dropdown', className),
    children: jsx(Tippy, Object.assign({
      interactive: true,
      interactiveBorder: 20,
      arrow: false,
      placement: "bottom-start",
      visible: isDropdownVisible(),
      onHidden: function onHidden(e) {
        setShouldRenderContent(false);
        if (_onHidden) _onHidden(e);
      },
      onShow: function onShow(e) {
        setShouldRenderContent(true);
        if (_onShow) _onShow(e);
      },
      trigger: isVisibleSet || shouldHideOnSelect ? undefined : triggerExtended,
      content: shouldRenderContent && (shouldHideOnSelect && !isVisibleSet ? jsx("div", {
        onClick: toggleHideOnSelectVisibilityState,
        children: content
      }) : content),
      onClickOutside: handleClickOutside,
      appendTo: appendToLocal,
      className: "cogs-v10 cogs-dropdown__tippybox"
    }, otherProps, {
      children: shouldHideOnSelect && !isVisibleSet ? jsx("div", {
        onClick: toggleHideOnSelectVisibilityState,
        children: children
      }) :
      // <span> wrapper is necessary for children that are Functional Component instances
      // that do not use React#forwardRef. See https://github.com/atomiks/tippyjs-react#component-children
      jsx("span", {
        role: "button",
        children: children
      })
    }))
  });
  /* eslint-enable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
};

export { Dropdown };
